import { GridColDef } from '@mui/x-data-grid';
import Avatar from '../../../components/Avatar/Avatar';
import { IdCardsColumnsWithCheckboxArgs } from '../types/IdCardTypes';
import { NameTypography } from '../styled';
import { RelationType } from '../../../enums';
import StyledCheckbox from '../../common/styled/Checkbox';

const DEFAULT_PAGINATION_MODEL = { page: 0, pageSize: 25 };

const relationTypes = [
  { label: 'Father', value: RelationType.FATHER },
  { label: 'Mother', value: RelationType.MOTHER },
  { label: 'Guardian', value: RelationType.GUARDIAN },
  { label: 'Student', value: RelationType.STUDENT }
];

function getIdCardsColumns({
  selectedIds,
  onHeaderCheckboxClick,
  onCellCheckboxClick,
  allRowsSelected,
  isSomeRowsSelected,
  relationType
}: IdCardsColumnsWithCheckboxArgs & {
  relationType?: RelationType;
}): GridColDef[] {
  const isStudent = relationType === RelationType.STUDENT || !relationType;
  const relationLabel = !isStudent
    ? relationTypes.find((relation) => relation.value === relationType)
        ?.label || 'Relation'
    : 'Student';
  const photoHeader = `${relationLabel} Photo`;
  const nameHeader = `${relationLabel} Name`;
  const studentNameColumn: GridColDef | null = !isStudent
    ? {
        field: 'studentName',
        headerName: 'Student Name',
        flex: 1,
        minWidth: 180,
        renderCell: (params) => <NameTypography>{params.value}</NameTypography>
      }
    : null;
  return [
    {
      field: 'select',
      headerName: '',
      width: 60,
      sortable: false,
      disableColumnMenu: true,
      headerAlign: 'center',
      align: 'center',
      renderHeader: () => (
        <StyledCheckbox
          checked={allRowsSelected}
          indeterminate={isSomeRowsSelected}
          onChange={onHeaderCheckboxClick}
        />
      ),
      renderCell: (params: any) => (
        <StyledCheckbox
          checked={selectedIds.includes(params.row.id)}
          onChange={() => onCellCheckboxClick(params.row.id)}
        />
      )
    },
    {
      field: 'photoUrl',
      headerName: photoHeader,
      flex: 1,
      minWidth: 60,
      renderCell: (params) =>
        params.value ? (
          <Avatar
            src={params.value as string}
            alt={params.row.name || 'user'}
            width={34}
            height={34}
            variant='circular'
          />
        ) : (
          '—'
        )
    },
    {
      field: 'name',
      headerName: nameHeader,
      flex: 1,
      minWidth: 180,
      renderCell: (params) => <NameTypography>{params.value}</NameTypography>
    },
    ...(studentNameColumn ? [studentNameColumn] : []),
    {
      field: 'enrollmentNumber',
      headerName: 'Student Enrollment No',
      flex: 1,
      minWidth: 180,
      renderCell: (params) => <NameTypography>{params.value}</NameTypography>
    }
  ];
}

export { relationTypes, getIdCardsColumns, DEFAULT_PAGINATION_MODEL };
